import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class FlashMessageItem extends Component {
  renderIcon() {
    const { type } = this.props;
    if (type === "danger") {
      return <FontAwesomeIcon icon={["fas", "ban"]} />;
    } else if (type === "success") {
      return <FontAwesomeIcon icon={["fas", "check"]} />;
    }
  }

  render() {
    return (
      <div
        className={`alert alert-${this.props.type} alert-dismissible`}
        style={this.props.style}
      >
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-hidden="true"
        >
          ×
        </button>
        <h5>
          {this.renderIcon()}
          {typeof this.props.title !== "undefined" && ` ${this.props.title}`}
        </h5>
        {typeof this.props.messages !== "undefined" && (
          <ul>
            {this.props.messages.map((message, i) => (
              <li key={i}>{message}</li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/FlashMessage/FlashMessageItem.js